export default __webpack_public_path__ + "static/media/genesy.a4a3c771.png";